import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import MerchandiseBanner from '../components/MerchandiseBanner';
import About from '../components/About';
import Services from '../components/Services';
import OtherServices from '../components/OtherServices';
import ServicesPreview from '../components/ServicesPreview';
import Testimonials from '../components/Testimonials';
import Partners from '../components/Partners';
import GlobalMap from '../components/GlobalMap';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <Header />
      <Hero />
      <Stats />
      <MerchandiseBanner />
      <About />
      <Services />
      <OtherServices />
      <Testimonials />
      <GlobalMap />
      <Partners />
      <ServicesPreview />
      <Footer />
    </div>
  );
};

export default HomePage;
